import { createContext, useState, useMemo, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Agreement from "../../components/creditInfoForm/steps/agreement";
import { useGlobalContext } from "./../globalContext";
import useStepFourValues from "./stepFourValues";
import useStepThreeValues from "./stepThreeValues";

export const CreditInfoStepsContext = createContext(null);

export function CreditInfoStepsContextProvider({ children }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const {
    globalData: { status },
  } = useGlobalContext();
  const { stepThreeValues, setStepThreeValues } = useStepThreeValues();
  const { stepFourValues, setStepFourValues } = useStepFourValues();

  const [redirectUrl, setRedirectUrl] = useState(null);

  const [activeStep, setActiveStep] = useState({
    id: 1,
    component: <Agreement />,
    route: `/creditinfo/agreement/${i18n.language}`,
  });

  const steps = useMemo(
    () => [
      {
        id: 1,
        title: t("confirmationStep1"),
        disabled: true,
        route: `/creditinfo/agreement/${i18n.language}`,
      },
      {
        id: 2,
        title: t("identificationStep2"),
        disabled: status !== "approved",
        route: `/creditinfo/Identomat/${i18n.language}`,
      },
      {
        id: 3,
        title: t("identityInformation3"),
        disabled: status !== "approved",
        route: `/creditinfo/step/3`,
      },
      {
        id: 4,
        title: t("applicationForm4"),
        disabled: status !== "approved",
        route: `/creditinfo/step/4`,
      },
      {
        id: 5,
        title: t("identityInformation6"),
        disabled: status !== "approved",
        route: `/creditinfo/step/5`,
      },
    ],
    [status, i18n.language, t]
  );

  const nextStep = () => {
    steps.forEach((step) => {
      if (step.id === activeStep.id + 1) {
        history.push(step.route);
      }
    });
  };

  const prevStep = () => {
    if (activeStep.id - 1 !== 2) {
      steps.forEach((step) => {
        if (step.id === activeStep.id - 1) {
          history.push(step.route);
        }
      });
    }
  };

  return (
    <CreditInfoStepsContext.Provider
      value={{
        activeStep,
        nextStep,
        prevStep,
        redirectUrl,
        setRedirectUrl,
        steps,
        setActiveStep,
        stepThreeValues,
        setStepThreeValues,
        stepFourValues,
        setStepFourValues,
      }}
    >
      {children}
    </CreditInfoStepsContext.Provider>
  );
}

export function useCreditInfoStepsContext() {
  const value = useContext(CreditInfoStepsContext);
  if (!value) {
    throw new Error("creditInfo Steps context Provider is not defined");
  }
  return value;
}
